var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width || '19',"height":"11","viewBox":"0 0 19 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.793 0.439453L18.2072 1.85367L9.50008 10.5608L0.792969 1.85367L2.20718 0.439453L9.50008 7.73235L16.793 0.439453Z","fill":_vm.fill || 'white'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }